// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--24bmA","footerButton":"Footer-module--footerButton--1NVNJ"};